// extracted by css-extract-rspack-plugin
export default {"Box":"delete-field-dialog-module__Box__C47Ss","Text":"delete-field-dialog-module__Text__Xp61r"};